import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const Home = lazy(() => import("../pages/home/page"));
const WebsiteDesign = lazy(() => import("../pages/website-design/page"));
const PatchogueWebDesign = lazy(() => import("../pages/patchogue-web-design/page"));
const BellportWebDesign = lazy(() => import("../pages/bellport-web-design/page"));
const Subscribe30 = lazy(() => import("../pages/subscribe-30/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
import Subscribe40Page from '../pages/subscribe-40/page';
import Subscribe50Page from '../pages/subscribe-50/page';
const DugoLawCaseStudy = lazy(() => import("../pages/portfolio/dugo-law/page"));
const GlennsDonutsCaseStudy = lazy(() => import("../pages/portfolio/glenns-donuts/page"));
const Portfolio = lazy(() => import("../pages/portfolio/page"));
const LongIslandWebDesign = lazy(() => import("../pages/long-island-web-design/page"));
const Videography = lazy(() => import("../pages/videography/page"));
const EthicalHacking = lazy(() => import("../pages/ethical-hacking/page"));
const VideoEditing = lazy(() => import("../pages/video-editing/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/website-design",
    element: <WebsiteDesign />,
  },
  {
    path: "/website-design-development-patchogue-ny",
    element: <PatchogueWebDesign />,
  },
  {
    path: "/website-design-development-bellport-ny",
    element: <BellportWebDesign />,
  },
  {
    path: "/subscribe-30",
    element: <Subscribe30 />,
  },
  {
    path: '/subscribe-40',
    element: <Subscribe40Page />,
  },
  {
    path: '/subscribe-50',
    element: <Subscribe50Page />,
  },
  {
    path: "/portfolio",
    element: <Portfolio />,
  },
  {
    path: "/portfolio/dugo-law",
    element: <DugoLawCaseStudy />,
  },
  {
    path: "/portfolio/glenns-donuts",
    element: <GlennsDonutsCaseStudy />,
  },
  {
    path: "/website-design-long-island",
    element: <LongIslandWebDesign />,
  },
  {
    path: "/videography",
    element: <Videography />,
  },
  {
    path: "/ethical-hacking",
    element: <EthicalHacking />,
  },
  {
    path: "/video-editing",
    element: <VideoEditing />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
